import * as React from 'react';
import { LayoutFooter } from './layout/footer';
import { LayoutHeader } from './layout/header';
import { Body } from '../styled/principal-styled';

export const Layout = ({ children, headerProps }) => (
  <Body>
    <LayoutHeader {...headerProps} />
    {children}
    <LayoutFooter />
  </Body>
);
